import React from 'react';
import { Link } from '@/kenya_friars_components/links';
import { Button } from '@/kenya_friars_components/buttons';
import './BecomeAFriend.css';

export const BecomeAFriend: React.FC = () => {
  return (
    <section className="kf-become-friend">
      <div className="container">
        <div className="kf-become-friend__content">
          <img
            src="/CONVKENYA_Transparent.png"
            alt="Kenya Friars Logo"
            className="kf-become-friend__logo"
          />
          <div className="kf-become-friend__text">
            <h2 className="kf-become-friend__title">
              Become A Friend Of The Conventual Franciscan Friars
            </h2>
            <p className="kf-become-friend__description">
              Your support enables us to continue our mission of peace, justice, and charity.
            </p>
          </div>
          <div className="kf-become-friend__cta">
            <Link to="/donation">
              <Button variant="gold" size="lg">DONATE TODAY</Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
